import { Link } from '@tanstack/react-router'
import { SearchX } from 'lucide-react'
import { useT } from '@/shared/i18n'
import { Button, EmptyState } from '@/shared/ui'

export function NotFoundPage() {
  const t = useT()
  return (
    <main className="flex min-h-[60vh] items-center justify-center p-6">
      <EmptyState
        icon={<SearchX />}
        title={t('errors.notFoundTitle')}
        description={t('errors.notFoundDescription')}
        action={
          <Button asChild variant="outline">
            <Link to="/">{t('actions.backToStart')}</Link>
          </Button>
        }
      />
    </main>
  )
}
